import { api } from "./client";

export type DestinationRow = {
  id: string;
  type: "local" | "usb" | "sftp" | "r2";
  label: string;
  path_or_uri: string;
  host_agent: string;
  host_agent_label: string;
  host_agent_hostname: string;
  restic_repo_initialized: boolean;
  last_init_error: string;
  created_at: string;
  updated_at: string;
};

export type JobRow = {
  id: string;
  label: string;
  destination: string;
  destination_label: string;
  source_agent: string;
  source_agent_label: string;
  source_agent_hostname: string;
  paths: string[];
  excludes: string[];
  schedule_cron: string;
  enabled: boolean;
  next_run_at: string | null;
  last_run: string | null;
  created_at: string;
  updated_at: string;
};

export type RunRow = {
  id: string;
  job: string;
  job_label: string;
  started_at: string;
  finished_at: string | null;
  status: "running" | "succeeded" | "failed" | "interrupted";
  restic_snapshot_id: string;
  files_count: number | null;
  bytes_total: number | null;
  bytes_added: number | null;
  error_message: string;
};

export async function listDestinations() {
  const { data } = await api.get<{ results: DestinationRow[] }>("/backups/destinations/");
  return data;
}

export type CreateDestinationPayload = {
  type: "local" | "usb";
  host_agent_id: string;
  path: string;
  label: string;
};

export async function createDestination(p: CreateDestinationPayload) {
  const { data } = await api.post<DestinationRow>("/backups/destinations/", p);
  return data;
}

export async function listJobs() {
  const { data } = await api.get<{ results: JobRow[] }>("/backups/jobs/");
  return data;
}

export type CreateJobPayload = {
  destination_id: string;
  source_agent_id: string;
  paths: string[];
  excludes?: string[];
  schedule_cron: string;
  label?: string;
};

export async function createJob(p: CreateJobPayload) {
  const { data } = await api.post<JobRow>("/backups/jobs/", p);
  return data;
}

export async function runJobNow(jobId: string) {
  const { data } = await api.post<RunRow>(`/backups/jobs/${jobId}/run-now`);
  return data;
}

export async function listJobRuns(jobId: string) {
  const { data } = await api.get<{ results: RunRow[] }>(`/backups/jobs/${jobId}/runs/`);
  return data;
}

export async function restoreFromRun(jobId: string, runId: string) {
  await api.post(`/backups/jobs/${jobId}/restore`, { run_id: runId });
}
